// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zco2oj5scaoRQVLwpE3x{flex-direction:column;gap:16px;display:flex}.u6JryJzHOrwT4DGJnxF1{white-space:nowrap;justify-content:center;gap:8px;display:flex}.MPBFCY3u3cY5ov4pKVQV{min-width:124px}.ymfomL2DlMwV430pr1aG{width:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `zco2oj5scaoRQVLwpE3x`,
	"buttonsRow": `u6JryJzHOrwT4DGJnxF1`,
	"button": `MPBFCY3u3cY5ov4pKVQV`,
	"alertError": `ymfomL2DlMwV430pr1aG`
};
export default ___CSS_LOADER_EXPORT___;
